require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-basic-styles-sandbox-preview-retirement-page.json") })
        }
      }, "path---es-basic-styles-sandbox-preview-retirement-page");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-basic-styles-sandbox-preview-retirement-page!./.cache/json/es-basic-styles-sandbox-preview-retirement-page.json
// module id = 2417
// module chunks = 231608221292675